export function sum(acc, val) {
  return acc + val;
};
